import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeVesselListItem extends SearchModelBase {
    vesselName: string = '';
    country: string = '';
    vesselFlag: string = '';
    lloydsCode: string = '';
    groupName: string = '';
    cid: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Vessel Name', width: 500, dataIndex: 'vesselName'}),
        XCol.Create({ col: 1, text: 'Country', width: 70, dataIndex: 'country'}),
        XCol.Create({ col: 2, text: 'Vessel Flag', width: 150, dataIndex: 'vesselFlag'}),
        XCol.Create({ col: 3, text: 'Lloyds Code', width: 150, dataIndex: 'lloydsCode'}),
        XCol.Create({ col: 4, text: 'Group', width: 70, dataIndex: 'groupName'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeVesselListItem.prototype.vesselName, orderByAscending: true };

    public static formatData(data: CodeVesselListItem[]) {
        return data.map((d: CodeVesselListItem) => ({
          ...d,
        }));
    }

}
